<!-- Comment Dialog - positioned near edited data point -->
@if (commentDialogState().show) {
  <!-- Backdrop overlay -->
  <div
    class="position-fixed top-0 start-0 w-100 h-100 comment-backdrop"
    tabindex="0"
    role="button"
    aria-label="Close comment dialog"
    (click)="closeCommentDialog()"
    (keydown.escape)="closeCommentDialog()"
  >
  </div>

  <!-- Comment dialog -->
  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
  <div
    class="position-fixed bg-white rounded shadow-lg border comment-dialog"
    role="dialog"
    aria-labelledby="comment-dialog-title"
    aria-modal="true"
    [style.left]="commentDialogPosition().left"
    [style.top]="commentDialogPosition().top"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
      <strong id="comment-dialog-title" class="mb-0">Add Comment</strong>
      <button
        type="button"
        class="btn btn-sm btn-ghost comment-close-btn"
        aria-label="Close"
        (click)="closeCommentDialog()"
      >
        ×
      </button>
    </div>

    <!-- Body -->
    <div class="p-3">
      @if (commentDialogState(); as state) {
        <p class="mb-2 text-secondary small">
          <strong>{{ getChangesSummary(state) }}</strong>
        </p>
      }
      <textarea
        #commentTextarea
        class="form-control form-control-sm"
        rows="2"
        placeholder="Add optional comment..."
        aria-label="Comment text"
        [formControl]="commentInputControl"
        (keydown.enter)="saveComment($event)"
        (keydown.escape)="closeCommentDialog()"
      >
      </textarea>
    </div>

    <!-- Footer -->
    <div class="d-flex justify-content-end gap-2 p-3 border-top bg-light">
      <button type="button" class="btn btn-secondary btn-sm" (click)="closeCommentDialog()">
        Skip
      </button>
      <button type="button" class="btn btn-primary btn-sm" (click)="saveComment()"> Save </button>
    </div>
  </div>
}
